import { map } from 'rxjs/operators';
import { forkJoin, EMPTY } from 'rxjs';
import { INSTITUTION_ACTIONS } from '../common';
import http from '../../helpers/APIHelper';

export const CIRB_ACTIONS = {
  SET_SELECTED_CIRB: '@regulatory/cirb/setSelectedCirb',
  PROTOCOL: '@regulatory/cirb/getprotocoldetails',
  UPDATE_OVERRIDE_PI: '@regulatory/cirb/updateOverridePi',
  GET_SITE_DETAILS: '@regulatory/cirb/getSiteDetails',
  CLEAR_SITE_DETAILS: '@regulatory/cirb/clearSiteDetails',
  GET_PROTOCOL_APPROVAL: '@regulatory/cirb/getProtocolApproval',
  CLEAR_PROTOCOL_APPROVAL: '@regulatory/cirb/clearProtocolApproval',
  GET_PROTOCOL_VERSIONS: '@regulatory/cirb/getProtocolVersions',
  CLEAR_PROTOCOL_ADDITIONAL_DETAILS: '@regulatory/cirb/clearProtocolAdditionalDetails',
  IS_LOADING_ADDITIONAL_DETAIL: '@regulatory/cirb/isLoadingAdditionalDetails',
  CLEAR_SITE_ADDITIONAL_DETAILS: '@regulatory/cirb/clearSiteAdditionalDetails',
  SITE_PROCESS_VALIATION_HANDLER: '@regulatory/cirb/siteProcessValidationHandler',
  SET_SITE_EVENTS: '@regulatory/cirb/setSiteEvents',
  SET_MISSING_PREFERENCES: '@regulatory/cirb/setMissingPreferences',
  SET_SITE_PREFERENCES: '@regulatory/cirb/setSitePreferences',
  SET_SITE_APPROVALS: '@regulatory/cirb/setSiteApprovals',
  SET_DUPLICATE_EVENTS: '@regulatory/cirb/setDuplicateEvents',
  SET_EVENTS_HISTORY: '@regulatory/cirb/setEventsHistory',
  SET_SIGNATORY_CONTACTS: '@regulatory/cirb/setSignatoryContacts'
};

export const setSelectedCirb = (data, index) => (dispatch) => {
  const action = {
    type: CIRB_ACTIONS.SET_SELECTED_CIRB,
    payload: {
      data,
      index
    }
  };
  dispatch(action);
};

export const getSiteDetails = (token, loggerInfo, siteCtepId, cirbEventId) => (dispatch) => http
  .getWithToken(
    `site-data-service/v1/sites/number/${siteCtepId}/details/cirb/${cirbEventId}/approvals`,
    token,
    loggerInfo
  )
  .subscribe(
    (resp) => {
      dispatch({
        type: CIRB_ACTIONS.GET_SITE_DETAILS,
        payload: resp.response
      });
    },
    (error) => {
      console.log('err: ', error);
    }
  );

export const clearSiteDetails = () => (dispatch) => {
  const action = {
    type: CIRB_ACTIONS.CLEAR_SITE_DETAILS
  };
  dispatch(action);
};

export const updateOverrideCtepId = (token, loggerInfo, cirbEventId, postBody) => () => http
  .putWithToken(
    `site-data-service/v1/sites/id/${cirbEventId}/overridepi`,
    token,
    JSON.stringify(postBody),
    loggerInfo,
    'text'
  )
  .pipe(map((resp) => resp));

export const getProtocolDetails = (token, loggerInfo, id) => (dispatch) => {
  http.getWithToken(`protocol-data-service/v1/protocols/number/${id}/summary`, token, loggerInfo).subscribe(
    (resp) => {
      dispatch({
        type: CIRB_ACTIONS.PROTOCOL,
        payload: resp.response
      });
    },
    (error) => {
      dispatch({
        type: CIRB_ACTIONS.PROTOCOL,
        payload: error
      });
    }
  );
};

export const saveCirb = (token, loggerInfo, postBody) => () => http
  .putWithToken(`regulatory-data-service/v1/cap/event/${postBody.id}`, token, JSON.stringify(postBody), loggerInfo)
  .pipe(map((resp) => resp));

const changeIsLoadingAdditionalDetails = (dispatch, isLoadingAdditionalDetails) => {
  dispatch({
    type: CIRB_ACTIONS.IS_LOADING_ADDITIONAL_DETAIL,
    isLoadingAdditionalDetails
  });
};

const getCirbSitePaticipants = (postBody, token, loggerInfo, protocolNumber) => http
  .postWithToken(
    `protocol-data-service/v1/protocols/number/${protocolNumber}/cirbsiteparticipants`,
    token,
    JSON.stringify(postBody),
    loggerInfo
  )
  .pipe(map((resp) => resp.response.data));

const getCirbSitePaticipantsFilter = (filter) => ({
  filter: [filter],
  first: 0,
  isMetaRequired: false,
  size: -1,
  sort: []
});

const getMissingPreferences = (token, loggerInfo, protocolNumber) => (dispatch) => {
  const postBody = getCirbSitePaticipantsFilter({
    field: 'isMissingSitePreference',
    operation: '=',
    value: 'true'
  });
  return getCirbSitePaticipants(postBody, token, loggerInfo, protocolNumber).pipe(
    map((data) => {
      dispatch({
        type: CIRB_ACTIONS.SET_MISSING_PREFERENCES,
        payload: data
      });
    })
  );
};

const getSiteEventDetails = (token, loggerInfo, protocolNumber, approvalDate) => (dispatch) => {
  const postBody = getCirbSitePaticipantsFilter({
    field: 'siteStartDate',
    operation: '>=',
    value: approvalDate
  });
  return getCirbSitePaticipants(postBody, token, loggerInfo, protocolNumber).pipe(
    map((data) => {
      dispatch({
        type: CIRB_ACTIONS.SET_SITE_EVENTS,
        payload: data
      });
    })
  );
};

const getDuplicateEvents = (token, loggerInfo, cirbEventId, filter) => (dispatch) => http.postWithToken(`regulatory-data-service/v1/cap/id/${cirbEventId}/duplicates`, token, filter, loggerInfo).pipe(
  map((resp) => {
    dispatch({
      type: CIRB_ACTIONS.SET_DUPLICATE_EVENTS,
      payload: resp.response
    });
  })
);

const getEventsHistory = (token, loggerInfo, cirbEventId) => (dispatch) => http.getWithToken(`regulatory-data-service/v1/cap/id/${cirbEventId}/eventshistory`, token, loggerInfo).pipe(
  map((resp) => {
    dispatch({
      type: CIRB_ACTIONS.SET_EVENTS_HISTORY,
      payload: resp.response
    });
  })
);

const getProtocolAdditionalDetails = (
  token,
  loggerInfo,
  protocolNumber,
  approvalDate,
  cirbEventId,
  prtId,
  dispatch
) => {
  changeIsLoadingAdditionalDetails(dispatch, true);
  forkJoin({
    siteEvents: getSiteEventDetails(token, loggerInfo, protocolNumber, approvalDate)(dispatch),
    missingPreference: getMissingPreferences(token, loggerInfo, protocolNumber)(dispatch),
    duplicateEvents: getDuplicateEvents(token, loggerInfo, cirbEventId, {
      prtId,
      eventCategory: 'PROTOCOL APPROVAL'
    })(dispatch),
    eventsHistory: getEventsHistory(token, loggerInfo, cirbEventId)(dispatch)
  }).subscribe(
    () => changeIsLoadingAdditionalDetails(dispatch, false),
    () => changeIsLoadingAdditionalDetails(dispatch, false)
  );
};

export const clearProtocolAdditionalDetails = () => (dispatch) => {
  const action = {
    type: CIRB_ACTIONS.CLEAR_PROTOCOL_ADDITIONAL_DETAILS
  };
  dispatch(action);
};

export const getProtocolApproval = (token, loggerInfo, { protocolNumber, id, prtId }) => (dispatch) => http
  .getWithToken(
    `protocol-data-service/v1/protocols/number/${protocolNumber}/cirb/${id}/approvals`,
    token,
    loggerInfo
  )
  .subscribe(
    (resp) => {
      const { rssApprovalDate, approvalDate } = resp.response;
      const resDate = rssApprovalDate || approvalDate;
      if (resDate != null) {
        getProtocolAdditionalDetails(token, loggerInfo, protocolNumber, resDate, id, prtId, dispatch);
      }
      dispatch({
        type: CIRB_ACTIONS.GET_PROTOCOL_APPROVAL,
        payload: resp.response
      });
    },
    (error) => {
      console.log('err: ', error);
    }
  );

const getSitePreferences = (token, loggerInfo, cirbEventId) => (dispatch) => http.getWithToken(`regulatory-data-service/v1/cap/id/${cirbEventId}/sitepreferences`, token, loggerInfo).pipe(
  map((resp) => {
    dispatch({
      type: CIRB_ACTIONS.SET_SITE_PREFERENCES,
      payload: resp.response
    });
  })
);

const getSignatoryContacts = (token, loggerInfo, siteCtepId) => (dispatch) => http.getWithToken(`site-data-service/v1/sites/number/${siteCtepId}/signatorycontacts`, token, loggerInfo).pipe(
  map((resp) => {
    dispatch({
      type: CIRB_ACTIONS.SET_SIGNATORY_CONTACTS,
      payload: resp.response
    });
  })
);

const getSiteApprovals = (token, loggerInfo, prtId, siteCtepId) => (dispatch) => {
  if (prtId != null) {
    return http
      .getWithToken(`site-data-service/v1/sites/number/${siteCtepId}/details/${prtId}/siteApprovals`, token, loggerInfo)
      .pipe(
        map((resp) => {
          dispatch({
            type: CIRB_ACTIONS.SET_SITE_APPROVALS,
            payload: resp.response
          });
        })
      );
  }
  return EMPTY;
};

export const getSiteAdditionalDetails = (token, loggerInfo, { siteCtepId, prtId, id }) => (dispatch) => {
  changeIsLoadingAdditionalDetails(dispatch, true);
  forkJoin({
    signatoryContacts: getSignatoryContacts(token, loggerInfo, siteCtepId)(dispatch),
    siteApprovals: getSiteApprovals(token, loggerInfo, prtId, siteCtepId)(dispatch),
    sitePreferences: getSitePreferences(token, loggerInfo, id)(dispatch),
    duplicateEvents: getDuplicateEvents(token, loggerInfo, id, {
      eventCategory: 'SITE PARTICIPATION',
      prtId,
      siteCtepId
    })(dispatch),
    eventsHistory: getEventsHistory(token, loggerInfo, id)(dispatch)
  }).subscribe(
    () => changeIsLoadingAdditionalDetails(dispatch, false),
    () => changeIsLoadingAdditionalDetails(dispatch, false)
  );
};

export const clearSiteAdditionalDetails = () => (dispatch) => {
  const action = {
    type: CIRB_ACTIONS.CLEAR_SITE_ADDITIONAL_DETAILS
  };
  dispatch(action);
};

export const clearProtocolApproval = () => (dispatch) => {
  const action = {
    type: CIRB_ACTIONS.CLEAR_PROTOCOL_APPROVAL
  };
  dispatch(action);
};

export const saveProtocolApproval = (token, loggerInfo, protocolNumber, cirbEventId, postBody) => () => http
  .putWithToken(
    `protocol-data-service/v1/protocols/number/${protocolNumber}/cirb/${cirbEventId}/approvals`,
    token,
    JSON.stringify(postBody),
    loggerInfo
  )
  .pipe(map((resp) => resp));

export const getProtocolVersions = (token, loggerInfo, protocolNumber, postBody = {}) => (dispatch) => {
  http
    .postWithToken(
      `protocol-data-service/v1/protocols/number/${protocolNumber}/versions`,
      token,
      JSON.stringify(postBody),
      loggerInfo
    )
    .subscribe(
      (resp) => {
        dispatch({
          type: CIRB_ACTIONS.GET_PROTOCOL_VERSIONS,
          payload: resp.response
        });
      },
      (error) => {
        console.log('err: ', error);
      }
    );
};

export const clearProtocolVersions = () => (dispatch) => {
  dispatch({
    type: CIRB_ACTIONS.GET_PROTOCOL_VERSIONS,
    payload: []
  });
};

export const siteProcessValidationHandler = (token, loggerInfo, data) => () => http
  .postWithToken(`regulatory-data-service/v1/cap/validate/eventprocess`, token, JSON.stringify(data), loggerInfo)
  .pipe(map((resp) => resp));

export const siteProcessHandler = (token, loggerInfo, data) => () => http
  .postWithToken(`regulatory-data-service/v1/cap/id/${data}/eventprocess`, token, {}, loggerInfo, 'text')
  .pipe(map((resp) => resp));

export const getSyncVersion = (token, loggerInfo, protocolNumber, versionDate) => http
  .getWithToken(
    `protocol-data-service/v1/protocols/number/${protocolNumber}/syncversion/${versionDate}`,
    token,
    loggerInfo
  )
  .pipe(map((resp) => resp.response));

export const saveEventHistory = (token, loggerInfo, capId, postBody) => (dispatch) => http
  .postWithToken(`regulatory-data-service/v1/cap/id/${capId}/eventshistory`, token, postBody, loggerInfo)
  .subscribe(() => getEventsHistory(token, loggerInfo, capId)(dispatch).subscribe());

export const getRosterSites = (token, loggerInfo, siteCtepId) => http
  .getWithToken(`irost-data-service/v1/sites/number/${siteCtepId}/rosteredsites`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

export const getRosterTree = (token, loggerInfo, siteCtepId, isActive = 'Y') => (dispatch) => http
  .getWithToken(
    `irost-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/sites/number/${siteCtepId}/status/${isActive}/tree`,
    token,
    loggerInfo
  )
  .subscribe((resp) => {
    const action = {
      type: INSTITUTION_ACTIONS.GET_ROSTERTREE_DATA,
      payload: {
        treeData: resp.response
      }
    };
    dispatch(action);
  });

export const capBrowserAction = (token, loggerInfo, filter) => () => {
  const payload = {
    filter,
    isMetaRequired: false,
    size: 5
  };
  return http.postWithToken(
    `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/cap/browse`,
    token,
    payload,
    loggerInfo
  );
};

export const clearProtocolDetails = () => (dispatch) => {
  dispatch({
    type: CIRB_ACTIONS.PROTOCOL,
    payload: {}
  });
};
